import { Injectable } from "@angular/core";
import { AmdocsAppsyncClientService } from 'amdocs-core-package';
import { Observable, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'  // This ensures the service is a singleton
})
export class SetUserNotificationService {
  constructor(
    private appSyncClient: AmdocsAppsyncClientService) {
  }

  setUserNotification(input): Observable<any> {
    const notificationMutation = `mutation SetUserDACNotifications($userDACNotificationInput: UserDACNotificationInput!) {
      setUserDACNotifications(userDACNotificationInput: $userDACNotificationInput) {
        isRead
        isSuccess
        message
        sys_id
      }
    }`;
    const param = input;

    return this.appSyncClient.call(notificationMutation, 'SetUserDACNotifications', param).pipe(
      mergeMap((res: any): Observable<any> => {
        return of(res);
      }),
      catchError(err => {
        console.log(err);
        return of({ error: err });
      })
    );
  }
}
